import { IEnvVars } from './types';

/**
 * Environment variable mapping functions
 */
const mapper = (key: keyof IEnvVars): string | undefined => {
  // Map common keys to Vite environment variables
  const keyMap: Record<keyof IEnvVars, string> = {
    API_URL: 'VITE_API_URL',
    COGNITO_USERPOOL_CLIENT_ID: 'VITE_COGNITO_USERPOOL_CLIENT_ID',
    COGNITO_USERPOOL_ID: 'VITE_COGNITO_USERPOOL_ID',
    COGNITO_DOMAIN: 'VITE_COGNITO_DOMAIN',
    JIMO_ID: 'VITE_JIMO_ID',
    ADMIN_URL: 'VITE_ADMIN_URL',
    GTM_ID: 'VITE_GTM_ID',
    GOOGLE_API_KEY: 'VITE_GOOGLE_API_KEY',
    GOOGLE_MAP_ID: 'VITE_GOOGLE_MAP_ID',
    DEV: 'DEV',
    MODE: 'MODE',
    ENV_NAME: 'VITE_ENV_NAME',
  };

  return import.meta.env[keyMap[key]];
};

/**
 * Get the environment variables for the current platform
 */
export const getEnv = (): IEnvVars => {
  return {
    API_URL: mapper('API_URL') || '',
    COGNITO_USERPOOL_CLIENT_ID: mapper('COGNITO_USERPOOL_CLIENT_ID') || '',
    COGNITO_USERPOOL_ID: mapper('COGNITO_USERPOOL_ID') || '',
    COGNITO_DOMAIN: mapper('COGNITO_DOMAIN') || '',
    JIMO_ID: mapper('JIMO_ID'),
    ADMIN_URL: mapper('ADMIN_URL'),
    ENV_NAME: mapper('ENV_NAME'),
    GOOGLE_API_KEY: mapper('GOOGLE_API_KEY'),
    GOOGLE_MAP_ID: mapper('GOOGLE_MAP_ID'),
    GTM_ID: mapper('GTM_ID'),
    DEV: import.meta.env.DEV,
    MODE: import.meta.env.MODE,
  };
};

/**
 * Get a specific environment variable
 * @param key The environment variable key
 * @returns The environment variable value
 */
export const getEnvVar = <K extends keyof IEnvVars>(key: K): IEnvVars[K] => {
  return getEnv()[key];
};
